export default "__VITE_ASSET__BYVHseJC__"